import * as types from '../../action-types';

export const getAllNavMenus = (data) => {
  return {
    type: types.GET_ALL_NAV_MENUS,
    payload: data,
  };
}
  
